import { render } from "./SelectBackgroundView.vue?vue&type=template&id=1609377a&scoped=true"
import script from "./SelectBackgroundView.vue?vue&type=script&lang=js"
export * from "./SelectBackgroundView.vue?vue&type=script&lang=js"

import "./SelectBackgroundView.vue?vue&type=style&index=0&id=1609377a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1609377a"

export default script